<template>
  <li>
    <router-link :to="item.route"
      >{{ item.text }} <slot></slot
    ></router-link>
  </li>
</template>

<script>
export default {
  name: "SideNavItem",
  props: {
    item: {
      type: Object,
      required: true,
      validator: (value) => {
        const keys = Object.keys(value);
        return keys.includes("route") && keys.includes("text");
      },
    },
    isCategory: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
